var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-col',_vm._b({staticClass:"poster-dashboard-widget poster-dashboard-widget__root"},'pui-col',_vm.$attrs,false),[_c('pui-flex',{staticClass:"poster-dashboard-widget__body",attrs:{"direction":_vm.direction}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }